module.exports = __webpack_public_path__ + "static/media/young.db16cc84.png";